(ns frontend.ui.component.lp-portal.column.pdf.view
  (:require
   [frontend.ui.component.lp-portal.page.pdf.view :as page]))

;; TODO This duplicate of frontend.ui.page.lp-portal.landing-page.private-equity.pdf.view/margin
;; should probably belong to a PDF submap of the theme
(def ^:private margin 15)

(defn column
  [& children]
  {:stack  children
   :margin [margin 0 margin 0]})

(defn columns
  [& children-list]
  {:columns (map column children-list)})

(defn columns-2-to-1
  [two-third-child one-third-child]
  {:columns [(-> (column two-third-child)
                 (assoc :width (int (* page/page-width (/ 2 3))))
                 (assoc :margin [margin 0 (* 2 margin) 0]))

             (-> (column one-third-child)
                 (assoc :width (int (* page/page-width (/ 1 3))))
                 (assoc :margin [margin 0 (* 2 margin) 0]))]})
